import "../assets/locale/da_DK.po"
import "../assets/locale/en_GB.po"
import "../assets/locale/nb_NO.po"
import "../assets/locale/sv_SE.po"
import "../assets/locale/fi_FI.po"
import "../assets/locale/fr_FR.po"
import "../assets/locale/de_DE.po"
import "../assets/locale/pl_PL.po"
